import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Morachichincholionlinebooking() {



    const cardData =
    {
        keyword: 'Morachi Chincholi Online Booking',
        heading: 'Anand Krushi Paryatan Kendra: Morachi Chincholi Online Booking',
        headingDescription: 'Planning a visit to the serene countryside? Make your trip effortless with Morachi Chincholi online booking at Anand Krushi Paryatan Kendra, a 40-acre agri-tourism destination just 55 km from Pune. Whether you are planning a one-day picnic, family gathering, school trip, or corporate outing, online booking ensures your experience is smooth and hassle-free. Through Morachi Chincholi online booking, guests can reserve entry passes, activity packages, group events, or overnight stays—all with ease. The farm offers a wide range of attractions including bullock cart and tractor rides, boating, horse riding, swimming, rain dance, magic shows, puppet shows, and traditional village games.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',
topPlaces: [
  {
    "title": "Anand Krushi Paryatan Kendra – Online Booking",
    "description": "Book day and overnight packages securely on their portal or by calling +91 96891 25047. Day package (₹600/adult, ₹300/child) includes breakfast, lunch, high tea, rain dance, pool, tractor & bullock-cart rides, adventure games, puppet/magic shows, bird watching, and more. Overnight option adds dinner and an evening bonfire (₹1,400/adult, ₹700/child)."
  },
  {
    "title": "Mhalasakant Agritourism – Advance Booking",
    "description": "Reserve your slot with 25% advance payment by calling +91 83088 92845. One‐day packages (₹800/adult, ₹600/child) include breakfast, sugarcane juice, unlimited Maharashtrian lunch, high tea, and full access to pool, rain dance, zip-line, archery, adventure games, bullock-cart/tractor ride, sports, magic shows, and more. School-picnic rates and hurda-party packages available."
  },
  {
    "title": "Mauli Krushi Paryatan Kendra – Email/Call Booking",
    "description": "Contact via +91 70206 52790 or booking@chincholimorachi.com to book cottages and day packages. Cottage stay costs ₹1,700/adult and ₹850/child (4–10 yrs); includes farm stay, meals, activities like bullock-cart rides, camping, hurda‑parties, bird watching, and children’s park."
  },
  {
    "title": "Mayur Krushi Paryatan – Family‑Style Booking",
    "description": "Reach out through their site to reserve limited, home‑style farm stays. Enjoy homemade meals from the wood‑fire chulha, peaceful cottage stay, petting farm, and guided farming. Ideal for small groups looking for authentic rural experience."
  },
  {
    "title": "Jay Malhar Krushi – Online & WhatsApp Booking",
    "description": "Call +91 97641 20777 to book day visits (₹750/adult, ₹500/child) that include water park, 45+ adventure activities, rain dance, hurda‑party, food festival with 40+ items, pool, rides, rural games, and guided tours. Group discounts for 10+ or 30+ persons apply."
  }
],




  "services": [
    {
      "name": "Online Ticket Booking for Morachi Chincholi",
      "description": "Streamline your visit with easy online ticket booking—choose dates, the number of visitors, and receive a digital pass via email or WhatsApp for seamless entry."
    },
    {
      "name": "One-Day Package Booking",
      "description": "Select from curated one-day itineraries including farm tours, adventure activities, meals, and cultural experiences—all available to book and pay for online in seconds."
    },
    {
      "name": "School Picnic Booking Portal",
      "description": "A dedicated online portal for schools to plan educational day trips, choose student-friendly packages, add-ons, and make group bookings with secure payment facilities."
    },
    {
      "name": "Group Visit Bookings Online",
      "description": "Book group excursions or family gatherings using our web platform—select group size, customize activities, and confirm multiple passes in a single transaction."
    },
    {
      "name": "Online Reservation for Farm Stays",
      "description": "Reserve comfortable farm accommodations in advance—choose tented or cottage stays, check availability in real time, and pay securely online for your weekend escape."
    },
    {
      "name": "Resort Booking in Morachi Chincholi",
      "description": "Search and book resorts in Morachi Chincholi via our online system—filter by amenities, view availability, and make instant reservations with included meals and services."
    },
    {
      "name": "Pre-Booking for Mango Mahotsav",
      "description": "Secure your spot at the seasonal Mango Festival ahead of time—online booking includes festival entry, tasting sessions, cultural shows, and special packages."
    },
    {
      "name": "Hurda Party Online Passes",
      "description": "Reserve hurda party passes online—choose between family, group, or corporate packages that include food, bonfire access, folk music, and games during the winter season."
    },
    {
      "name": "Camping Spot Booking Online",
      "description": "Reserve camping spots in our farm’s tented area with a few clicks—select your date, tent type, and add-ons such as guided walks or bonfire experiences."
    },
    {
      "name": "Online Payment Options",
      "description": "Multiple secure online payment modes available—credit/debit cards, UPI, wallets, and net banking—for booking tickets, packages, or stays without hassle."
    },
    {
      "name": "Family Event Reservation System",
      "description": "An online reservation system for families planning picnics, birthdays, or small events—choose event type, add special requests, and confirm your booking instantly."
    },
    {
      "name": "Weekend Visit Bookings",
      "description": "Guaranteed weekend availability via online booking. Choose your Saturday or Sunday slot in advance and receive confirmation along with detailed itinerary."
    },
    {
      "name": "Custom Tour Packages Online",
      "description": "Design your own farm tour online—select desired activities, meals, group size, and date—and get a custom package quote with easy booking functionality."
    },
    {
      "name": "Advance Slot Booking for Photoshoots",
      "description": "Reserve timeslots ahead for pre-wedding, family or event photoshoots—ensure exclusive access to scenic backdrops with decor, props, and assistant support included."
    },
    {
      "name": "Online Itinerary Planning for Morachi Chincholi",
      "description": "Build your full-day or multi-day plan online—choose activities, meals, stay options and get a downloadable itinerary with booking confirmations and QR code tickets."
    }
  ],
  "tableData": [
    ["Online Ticket Booking for Morachi Chincholi", "One-Day Package Booking"],
    ["School Picnic Booking Portal", "Group Visit Bookings Online"],
    ["Online Reservation for Farm Stays", "Resort Booking in Morachi Chincholi"],
    ["Pre-Booking for Mango Mahotsav", "Hurda Party Online Passes"],
    ["Camping Spot Booking Online", "Online Payment Options"],
    ["Family Event Reservation System", "Weekend Visit Bookings"],
    ["Custom Tour Packages Online", "Advance Slot Booking for Photoshoots"],
    ["Online Itinerary Planning for Morachi Chincholi", ""]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Convenient Online Booking",
    "WhyChoosedescription": "Most agro-tourism centers in Morachi Chincholi, like Anand Krushi Paryatan Kendra and Mhalasakant, offer easy online booking through their websites or WhatsApp—ensuring quick confirmation without needing to call."
  },
  {
    "WhyChooseheading": "Transparent Pricing & Packages",
    "WhyChoosedescription": "Online platforms display clear day, night, festival, and combo-package rates, along with details of inclusions like meals, activities, and accommodation—helping you choose the best option without confusion."
  },
  {
    "WhyChooseheading": "Real-Time Availability & Instant Confirmation",
    "WhyChoosedescription": "You can check availability on specific dates (including weekends and festival occasions) and receive immediate booking confirmation—letting you plan your trip with confidence."
  },
  {
    "WhyChooseheading": "Multiple Payment Options",
    "WhyChoosedescription": "Online booking supports UPI, credit/debit cards, and sometimes net banking, offering secure and hassle-free payment without needing to carry cash."
  },
  {
    "WhyChooseheading": "Convenient Add-Ons & Customizations",
    "WhyChoosedescription": "Some portals allow you to pre-select or add-on services like birthday decorations, corporate setups, dinner tables, or adventure activities—so you can tailor your booking to your needs."
  },
  {
    "WhyChooseheading": "Ease of Cancellations & Rescheduling",
    "WhyChoosedescription": "Booking online often includes clear cancellation and rescheduling policies, with easy date changes or refunds processed through the same portal."
  }
]
































    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Can I book activities and stays at Morachi Chincholi online?',
    answer: 'Yes, most resorts and agro-tourism centers in Morachi Chincholi offer online booking for day visits, stays, events, and activities.',
  },
  {
    id: 'FAQ2',
    question: 'Which platforms support online booking in Morachi Chincholi?',
    answer: 'You can book directly through resort websites, WhatsApp/phone, or third-party platforms like MakeMyTrip, Goibibo, and local agritourism portals.',
  },
  {
    id: 'FAQ3',
    question: 'Is a deposit required during online booking?',
    answer: 'Yes, typically a 25–50% advance deposit is required to confirm bookings, with the balance payable on arrival or check-out.',
  },
  {
    id: 'FAQ4',
    question: 'Can I choose and reserve specific activities online?',
    answer: 'Yes, many providers allow you to select add-on activities like tractor rides, ziplining, rain dance, or bonfire options during booking.',
  },
  {
    id: 'FAQ5',
    question: 'Is there a cancellation policy for online bookings?',
    answer: 'Yes, cancellation terms vary. Most offer full or partial refunds if cancelled at least 7–14 days prior; last-minute cancellations may incur a fee.',
  },
  {
    id: 'FAQ6',
    question: 'Are group bookings available online?',
    answer: 'Absolutely. You can book packages for family reunions, school picnics, corporate outings, or group stays online—group discounts may apply.',
  },
  {
    id: 'FAQ7',
    question: 'Do I receive an e-ticket or confirmation after booking?',
    answer: 'Yes, you will receive an online confirmation via email or WhatsApp, including booking details and venue directions.',
  },
  {
    id: 'FAQ8',
    question: 'Can I modify my online booking later?',
    answer: 'Yes, most resorts permit date or package modifications online or via customer support, subject to availability and applicable charges.',
  },
  {
    id: 'FAQ9',
    question: 'Is online payment secure for Morachi Chincholi bookings?',
    answer: 'Yes, reputable booking platforms and resort websites use secure payment gateways with SSL encryption and easy transaction options.',
  },
  {
    id: 'FAQ10',
    question: 'What information do I need to provide for online booking?',
    answer: 'You’ll need your name, contact number, email, number of guests, date(s), and any add-on preferences; sometimes ID proof is required on arrival.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Ms. Richa Kulkarni, Pune',
    feedback: "Booking online was simple and seamless. We received timely confirmation and couldn't wait to enjoy our day at Morachi Chincholi!",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mr. Ashwin More, PCMC',
    feedback: "We booked a corporate outing online for our team, and the process was smooth. The staff also confirmed add-on activities quickly via WhatsApp.",
    rating: 5,
  },
];


































    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];


const bookingSchema = {
  "@context": "https://schema.org",
  "@type": "TouristInformationCenter",
  "name": "Morachi Chincholi Online Booking",
  "description": "Book your visit to Morachi Chincholi online with ease. Reserve tickets for one-day packages, school picnics, group visits, farm stays, resort stays, Mango Mahotsav, Hurda parties, camping spots, and more. Enjoy secure online payments and advance itinerary planning.",
  "url": "https://morachichincholi.in/online-booking",
  "sameAs": "https://morachichincholi.in/",
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "Customer Service",
    "email": "info@morachichincholi.in",
    "telephone": "+91-12345-67890"
  },
  "serviceType": [
    "Online ticket booking",
    "Farm stay reservation",
    "Group visit booking",
    "Event booking",
    "Camping spot reservation"
  ],
  "areaServed": {
    "@type": "Place",
    "name": "Morachi Chincholi, Pune"
  }
};



    return (
        <div>
<Helmet>
  <title>Morachi Chincholi Online Booking | Farm Stay, Picnics & Events Reservations</title>
  <meta 
    name="description" 
    content="Easily book your visit to Morachi Chincholi online. Reserve tickets for day packages, school picnics, group visits, farm stays, Mango Mahotsav, Hurda parties, camping, and more with secure online payment options." 
  />
  <meta 
    name="keywords" 
    content="Online ticket booking for Morachi Chincholi, One-day package booking, School picnic booking portal, Group visit bookings online, Online reservation for farm stays, Resort booking in Morachi Chincholi, Pre-booking for Mango Mahotsav, Hurda party online passes, Camping spot booking online, Online payment options, Family event reservation system, Weekend visit bookings, Custom tour packages online, Advance slot booking for photoshoots, Online itinerary planning for Morachi Chincholi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(bookingSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/39.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Morachichincholionlinebooking;